import React from "react";
import { Warning } from "MODULES/shared/components";

export function SRPConditionMismatchWarning() {
  return (
    <Warning>
      Warning – For units purchased FOR STOCK, Condition and SRP Condition must
      match.
    </Warning>
  );
}



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/SRPConditionMismatchWarning.jsx